<template>
  <div class="profile-dropdown-wrapper">
    <a class="" href="#">
      <UserProfileAvatar :name="profileDisplayName" :photo="profilePhoto" class="header-profile-avatar"/>
    </a>

    <div ref="dropdownRef" class="dropdown-notifications small" uk-dropdown="pos: top-right;mode:click; animation: uk-animation-slide-bottom-small">
      <a href="#">
        <div class="dropdown-user-details">
          <div class="dropdown-user-avatar">
            <UserProfileAvatar :name="profileDisplayName" :photo="profilePhoto" class="dropdown-profile-avatar"/>
          </div>
          <div class="dropdown-user-name">
            {{ userInfo?.name }} {{ userInfo?.surname }}
            <span>{{ userInfo?.company_name }}</span>
          </div>
        </div>
      </a>

      <ul class="dropdown-user-menu">
        <li v-if="$roleCount() > 1 && !isNativeMobile">
          <a @click="navigateTo('company.dashboard')">
            <i class="uil-briefcase"></i>
            {{ $t("general.admin_panel") }}
          </a>
        </li>
        <li v-if="$roleCount() > 1 && !isNativeMobile" class="menu-divider"></li>
        <li>
          <a @click="navigateTo('user.profile')">
            <i class="icon-feather-settings"></i>
            {{ $t("general.profile") }}
          </a>
        </li>
        <li>
          <a @click="navigateTo('User.my-certification')">
            <i class="uil-award"></i> {{ $t("general.certificates") }}
          </a>
        </li>
        <li v-if="hasIyzicoIntegration" class="menu-divider"></li>
        <li v-if="hasIyzicoIntegration">
          <a @click="navigateTo('User.payment-history')">
            <i class="uil-shopping-basket"></i>
            {{ $t("general.my_order_past") }}
          </a>
        </li>
        <li class="menu-divider"></li>
        <li>
          <a @click="navigateTo('User.agreement')">
            <i class="icon-feather-info"></i>
            {{ $t("general.legal_notification") }}
          </a>
        </li>
        <li>
          <a @click="navigateTo('User.faq')">
            <i class="icon-feather-help-circle"></i>
            {{ $t("general.faq") }}
          </a>
        </li>
        <li>
          <a href="#" @click.prevent="onLogoutClick">
            <i class="icon-feather-log-out"></i>
            {{ $t("general.log_out") }}
          </a>
        </li>
      </ul>

      <!-- Dil secici (mobilde gorunur) -->
      <div class="profile-language-selector">
        <div class="language-switcher">
          <a v-for="lang in languages"
             :key="lang.lang"
             :class="{ active: lang.lang === currentLanguage }"
             class="lang-chip"
             href="#"
             @click.prevent="selectLanguage(lang.lang)">
            <img :alt="lang.name" :src="lang.flag" />
            <span>{{ lang.lang.toUpperCase() }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserProfileAvatar from "@/view/components/common/UserProfileAvatar.vue";
import i18nService from "@/core/services/i18n.service.js";
import { integrationMixin } from "@/core/mixin/integration.mixin";
import axios from "axios";

export default {
  name: "ProfileDropdown",
  mixins: [integrationMixin],
  components: {
    UserProfileAvatar,
  },
  props: {
    userInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      languages: i18nService.languages,
      currentLanguage: i18nService.getActiveLanguage(),
      isNativeMobile: !!window.ReactNativeWebView,
    };
  },
  computed: {
    profileDisplayName() {
      return (
        [this.userInfo?.name, this.userInfo?.surname].filter(Boolean).join(" ") ||
        this.userInfo?.fullname ||
        ""
      );
    },
    profilePhoto() {
      return this.userInfo?.photo || this.userInfo?.photo_link || "";
    },
  },
  methods: {
    hide() {
      if (this.$refs.dropdownRef) {
        UIkit.dropdown(this.$refs.dropdownRef).hide(0);
      }
    },
    navigateTo(routeName) {
      if (this.$route.name !== routeName) {
        this.$router.push({ name: routeName });
      }
      this.hide();
    },
    onLogoutClick() {
      this.$emit("logout");
    },
    selectLanguage(lang) {
      if (lang === this.currentLanguage) return;

      this.currentLanguage = lang;
      i18nService.setActiveLanguage(lang);
      if (this.$i18n) {
        this.$i18n.locale = lang;
      }
      window.dispatchEvent(new CustomEvent("app-language-changed", { detail: { lang } }));

      const langObj = this.languages.find((v) => v.lang === lang);
      if (langObj) {
        localStorage.setItem("activeLanguage", lang);
        localStorage.setItem("languageFlag", langObj.flag);
      }

      const token = this.apiHeaders?.Authorization;
      if (token) {
        axios.post("api/user/change-language", { code: lang }, {
          headers: this.apiHeaders,
          validateStatus: () => true,
        });
      }
    },
  },
};
</script>

<style lang="scss" src="./profile-dropdown.scss"></style>
